module.exports = __webpack_public_path__ + "static/logo-3297c90bcafd0a6d9df14c3c3b2d28f4.svg";